<template>
  <div class="market-page">
    <LazyPagesMarketComponentsSidebar
      :market="market"
    />

    <div class="market-page__body">
      <PagesMarketComponentsMarketInfo :market="market" />

      <LazyPagesMarketComponentsChartWrapper
        :chart="market.chart || []"
      />
      <div class="alternatives">
        <h2 class="body-title alternatives-title">
          {{ t('alternatives') }}
        </h2>
        <LazyPagesMarketsComponentsTable
          v-if="market.alternatives?.length"
          :markets="market.alternatives || []"
          :show-sort="false"
        />
      </div>

      <LazyPagesMarketComponentsDescriptions
        v-if="market.descriptions?.length"
        :descriptions="market.descriptions || []"
      />

      <LazyPagesMarketComponentsQuestionsHub
        v-if="market.question_answers?.length"
        :items="market.question_answers || []"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MarketFullInfo } from '~/graphql/generated/schema-types';

defineProps<{
  market: MarketFullInfo
}>();
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.market-page {
  display: flex;
  gap: 32px;

  &__body {
    width: calc(100% - 280px - 32px);
    display: flex;
    flex-direction: column;
    gap: 36px;

    &:deep(.body-title) {
      color: var(--surfaces-on-surface);
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px; /* 133.333% */
      margin-bottom: 24px;

      &.alternatives-title {
        margin-bottom: 16px;
      }
    }

    .alternatives {
      width: 100%;
      @media screen and (max-width: 1300px) {
        &:deep(.market-table) {
          overflow-x: auto;
          width: 100%;

          .market-table {
            &__header {
              display: none;
            }

            &-sort-select-wrapper {
              display: none !important;
            }

            &__body {
              padding-top: 0;
              gap: 12px;
              display: flex;
              flex-direction: row;

              .market-row {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
                padding: 12px 16px;
                min-width: 300px;

                .market-cell {
                  justify-content: space-between;
                  width: 100%;
                  padding: 0;

                  &__label {
                    display: inline;
                  }
                }

                .market-info {
                  justify-content: flex-start;
                  gap: 20px;
                }

                .rating {
                  order: 999;
                  position: relative;
                  padding-top: 16px;

                  svg {
                    margin-left: auto;
                  }

                  &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 1px;
                    background-image: linear-gradient(
                            to right,
                            #3A3F45 50%,
                            transparent 50%
                    );
                    background-size: 10px 4px;
                    background-repeat: repeat-x;
                  }
                }
              }
            }
          }
        }
        //display: ;

      }
      @media screen and (max-width: 500px) {
        width: unset;
        margin-right: -16px;

        &:deep(.market-table) {

          .market-table {
            &__body {
              .market-row {
                min-width: 90%;
                flex-shrink: 0;
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 850px) {
    width: 100%;
    flex-direction: column;
    gap: 16px;

    &__body {
      width: 100%;
      gap: 24px;

      &:deep(.body-title) {
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
}
</style>
